/* O16 Piemonte, launch day (sections/o16-pm-panels; snippets o16-pm-order, o16-pm-extras, o16-pm-sms-form).
   The clock and the first state come from the small inline script at the top of the section (root.o16PmClock),
   so the card never flashes the wrong content. This file:
   - ticks every second and swaps the state without a reload: before / doors (last 5 min) / ea (Early Access) / public;
   - every 30 s re-reads stock and order buttons from the server (Section Rendering API, no inventory APIs);
   - shows one order button for the edition picked at sign-up (localStorage.o16_pm_edition);
   - counts the sales pace only from stock changes this browser has seen (never extrapolated);
   - writes the countdown into the tab title (doors, Early Access) and restores it otherwise;
   - shows the family counter (fresh metafield only) and the shelf from ?books=.
   QA (only with ?pm_now=<ISO time>): pm_stock=1 shows the stock line, pm_family=<n> the family counter. */
(function () {
  var root = document.querySelector('.o16-pmp');
  if (!root) return;
  var q = new URLSearchParams(window.location.search);
  var qa = !!(window.o16PmQa && window.o16PmQa.on) && q.has('pm_now'); // QA parameters need the QA key (see the section's funnel_qa_key_hash)
  var clock = root.o16PmClock || null;
  var state = root.getAttribute('data-pm-state');
  var sectionId = root.getAttribute('data-section-id');
  var dock = root.querySelector('.o16-pmp__dock');
  var REFRESH = 30000, PACE_WINDOW = 600000;
  var JITTER = Math.random() * 5000; // each browser polls at its own offset, so 16:00 is not one wave of requests
  var lastFetch = Date.now(); // the page itself was just rendered by the server
  var baseTitle = document.title;
  var fmtN = function (n) { return Number(n).toLocaleString('en-US'); };
  function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function ls(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function two(n) { return ('0' + n).slice(-2); }
  // Reduced motion: a calm clock without ticking seconds (WCAG 2.2.2), e.g. 1:42 and 4 min.
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fmt(ms, withHours) {
    var t = Math.max(0, Math.ceil(ms / 1000));
    if (calm) { var mm = Math.ceil(t / 60); return withHours ? Math.floor(mm / 60) + ':' + two(mm % 60) : mm + ' min'; }
    var h = Math.floor(t / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
    return withHours ? h + ':' + two(m) + ':' + two(s) : two(Math.floor(t / 60)) + ':' + two(s);
  }
  // The family card (section setting card_states = family) knows no Friday: after the sign-up close it only points to the launch page,
  // so nothing here polls the server, sets the tab title or enables order buttons. The launch page (card_states = launch) runs all of it.
  var FAMILY_ONLY = root.getAttribute('data-card-states') === 'family';
  function live() { return !FAMILY_ONLY && (state === 'doors' || state === 'ea' || state === 'public'); }

  /* Shelf: ?books=no1,easy-pasta (link codes or product handles; nothing else is read). */
  (function () {
    var shelf = root.querySelector('[data-o16-pm-shelf]');
    var raw = q.get('books');
    if (!shelf || !raw || shelf.hasAttribute('data-o16-pm-shelf-off')) return; // switched off (setting "Show the shelf"): drawn hidden, only the gift wording reads it
    var want = raw.toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(function (s) { return /^[a-z0-9-]{1,60}$/.test(s); });
    var owned = 0;
    Array.prototype.forEach.call(shelf.querySelectorAll('[data-code]'), function (b) {
      var hit = want.indexOf(b.getAttribute('data-code')) > -1 || want.indexOf(b.getAttribute('data-handle')) > -1;
      b.hidden = !hit; if (hit) owned += 1;
    });
    if (!owned) return;
    Array.prototype.forEach.call(shelf.querySelectorAll('[data-o16-pm-shelf-slot] [data-tpl]'), function (l) { l.textContent = l.getAttribute('data-tpl').replace('{n}', owned + 1); });
    shelf.hidden = false;
  })();

  if (!clock) return; // the rest needs the launch-day clock (setting live_states)

  /* Family counter: switched on, fresh (written within 20 minutes) and at least the minimum. */
  each('[data-o16-pml-family]', function (el) {
    var n = parseInt(el.getAttribute('data-count'), 10), at = Date.parse(el.getAttribute('data-at'));
    var ok = el.getAttribute('data-on') === 'true' && n >= parseInt(el.getAttribute('data-min'), 10) && !isNaN(at) && Date.now() - at < 20 * 60000;
    if (qa && /^\d+$/.test(q.get('pm_family') || '')) { n = parseInt(q.get('pm_family'), 10); ok = true; }
    if (!ok) return;
    el.querySelector('[data-o16-pml-family-text]').textContent = el.getAttribute('data-tpl').replace('{count}', fmtN(n));
    el.hidden = false;
  });

  /* Order buttons: wait for 16:00; one button for the picked edition, with a way to switch. */
  function buttons() {
    var wait = state === 'doors' || state === 'before';
    var ed = ls('o16_pm_edition') || root.getAttribute('data-default-edition'); // the card always has one main button (the first edition unless another is picked)
    each('[data-o16-pml-btn]', function (a) {
      if (wait) { a.setAttribute('aria-disabled', 'true'); a.setAttribute('tabindex', '-1'); }
      else { a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
    });
    each('.o16-pml__live', function (box) {
      var btns = box.querySelectorAll('[data-o16-pml-btn]');
      var mine = null;
      Array.prototype.forEach.call(btns, function (a) { if (ed && a.getAttribute('data-edition') === ed) mine = a; });
      var wrap = box.querySelector('.o16-pml__btns');
      if (wrap) wrap.classList.toggle('is-picked', !!mine);
      Array.prototype.forEach.call(btns, function (a) {
        a.hidden = !!mine && a !== mine;
        var l = a.querySelector('[data-o16-pml-btn-label]');
        var txt = a === mine && a.getAttribute('data-my') ? a.getAttribute('data-my') : a.getAttribute('data-label');
        if (wait && a.getAttribute('data-wait')) txt = a.getAttribute('data-wait'); // "Opens at 15:00": placed and waiting, no layout jump at the doors
        if (l && txt && l.textContent !== txt) l.textContent = txt;
      });
      Array.prototype.forEach.call(box.querySelectorAll('[data-o16-pml-switch]'), function (s) {
        s.hidden = (btns.length ? !mine : !ed) || s.getAttribute('data-o16-pml-switch') === ed;
      });
    });
    if (qa && q.get('pm_buy') === '1') each('[data-card-qa]', function (el) { el.hidden = false; }); // QA only: shows the stand-in order buttons of an unpublished book
    if (qa && q.get('pm_stock') === '1') each('[data-o16-pml-stock][data-o16-pml-qa]', function (el) { el.hidden = false; });
  }
  document.addEventListener('o16:pm:edition', buttons);

  /* Sales pace: consumer stock as the server reports it, sampled on each refresh in this browser only. */
  var samples = [];
  function sample() {
    var el = root.querySelector('[data-o16-pml-stock]');
    if (!el || !live()) return;
    var left = parseInt(el.getAttribute('data-left'), 10);
    if (!isNaN(left)) samples.push({ t: Date.now(), left: left });
    pace();
  }
  function pace() {
    var out = root.querySelectorAll('[data-o16-pml-pace]');
    if (!out.length || samples.length < 2) return;
    var now = samples[samples.length - 1], first = samples[0], from = first, full = now.t - first.t >= PACE_WINDOW;
    if (full) for (var i = samples.length - 1; i >= 0; i--) { if (now.t - samples[i].t >= PACE_WINDOW) { from = samples[i]; break; } }
    var sold = from.left - now.left; // a restock makes this negative: then nothing is shown
    Array.prototype.forEach.call(out, function (p) {
      if (sold >= 10 && (state === 'ea' || state === 'public')) {
        p.textContent = p.getAttribute(full ? 'data-last' : 'data-since').replace('{n}', fmtN(sold));
        p.hidden = false;
      } else p.hidden = true;
    });
  }

  /* Head start as one quiet line: "Your head start ends at 17:00 London time (1 h 49 min)", minutes only. */
  var hsLast = '';
  function paintHeadstart(now) {
    var hs = root.querySelectorAll('[data-hs-h]');
    if (!hs.length) return;
    var mins = Math.max(0, Math.ceil((clock.public - now) / 60000)), key = String(mins);
    if (key === hsLast) return;
    hsLast = key;
    each('[data-hs-h]', function (el) { el.textContent = Math.floor(mins / 60); });
    each('[data-hs-m]', function (el) { el.textContent = mins % 60; });
  }

  /* Pre-armed checkout (setting "prearm_checkout", off by default): from the doors on, an order button for a visitor who typed a number
     on this device becomes the /buy link with country, language and phone filled in. The number never leaves the device before the tap. */
  var PREARM = root.hasAttribute('data-prearm');
  function arm() {
    if (!PREARM || !live() || !window.O16Phone || !window.O16Phone.buildBuyUrl) return;
    var d = null; try { d = JSON.parse(ls('o16_pm_buy') || 'null'); } catch (e) { /* none */ }
    if (!d || !d.p) return;
    each('[data-o16-pml-btn][data-variant]', function (a) {
      if (a.getAttribute('data-armed') === d.p) return;
      var u = window.O16Phone.buildBuyUrl({ variant: a.getAttribute('data-variant'), gift: a.getAttribute('data-gift-variant'), code: a.getAttribute('data-code'), iso: d.c, phone: d.p });
      if (u) { a.setAttribute('href', u); a.setAttribute('data-armed', d.p); }
    });
  }

  function paintClocks(now) {
    each('[data-o16-pml-clock]', function (el) {
      var pub = el.getAttribute('data-o16-pml-clock') === 'public';
      var txt = fmt((pub ? clock.public : clock.presale) - now, pub);
      if (el.textContent !== txt) el.textContent = txt;
    });
  }

  /* Tab title: the countdown while the doors open and during the head start; the page's own title otherwise. */
  var tabDoors = root.getAttribute('data-tab-doors'), tabOpen = root.getAttribute('data-tab-open'), tabEa = root.getAttribute('data-tab-ea');
  function title(now) {
    if (FAMILY_ONLY) return;
    var t = baseTitle;
    if (state === 'doors' && tabDoors) t = tabDoors.replace('{t}', fmt(clock.presale - now));
    if (state === 'ea' && (tabEa || tabOpen)) {
      var ea = tabEa ? tabEa.replace('{t}', fmt(clock.public - now, true)) : tabOpen;
      // In a background tab the line alternates, so "Open now" catches the eye between the ticks.
      t = document.hidden && tabOpen && Math.floor(now / 3000) % 2 === 0 ? tabOpen : ea;
    }
    if (document.title !== t) document.title = t;
  }

  function setDockOpen(open) {
    var btn = dock && dock.querySelector('[data-o16-pml-dock-toggle]');
    var pnl = dock && dock.querySelector('[data-o16-pml-dockpanel]');
    if (!btn || !pnl) return;
    dock.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) pnl.removeAttribute('inert'); else pnl.setAttribute('inert', '');
  }

  function refresh() {
    if (!sectionId || !live() || document.visibilityState === 'hidden') return;
    lastFetch = Date.now();
    var u = new URL(window.location.href);
    ['pm_now', 'pm_stock', 'pm_family', 'pm_wallet', 'books'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.set('sections', sectionId);
    // One cache key per 30 s window: every visitor in the same window shares the same server render.
    u.searchParams.set('pml', String(Math.floor(Date.now() / REFRESH)));
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        each('[data-o16-pml-live]', function (el) {
          var fresh = doc.querySelector('[data-o16-pml-live="' + el.getAttribute('data-o16-pml-live') + '"]');
          if (fresh && fresh.innerHTML !== el.innerHTML) el.innerHTML = fresh.innerHTML;
        });
        buttons();
        sample();
      })
      .catch(function () { /* keep what is on the page */ });
  }

  function tick() {
    var now = clock.now();
    var next = clock.state(now);
    if (next !== state) {
      var wasLive = live();
      state = next;
      root.setAttribute('data-pm-state', state);
      // At 16:00 the bar becomes the order bar, folded (the sign-up form in it may have been open).
      if (dock && (state === 'ea' || state === 'public')) {
        dock.classList.remove('is-open');
        var sp = dock.querySelector('[data-o16-pmp-dockpanel]'); if (sp) sp.setAttribute('inert', '');
      }
      buttons();
      hsLast = '';
      // Spread the first read over 2 s, so not every open tab asks in the same second.
      if ((live() && !wasLive) || state === 'ea') window.setTimeout(refresh, Math.random() * 2000);
    }
    paintClocks(now);
    paintHeadstart(now);
    arm();
    title(now);
    if (live() && Date.now() - lastFetch >= REFRESH + JITTER) refresh();
    window.setTimeout(tick, 1000 - (Date.now() % 1000) + 20);
  }

  // A tap on a waiting button does nothing (keyboard and touch alike).
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-o16-pml-btn]');
    if (a && a.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    var sw = e.target.closest('[data-o16-pml-switch]');
    if (sw) {
      try { window.localStorage.setItem('o16_pm_edition', sw.getAttribute('data-o16-pml-switch')); } catch (x) { /* storage blocked */ }
      document.dispatchEvent(new CustomEvent('o16:pm:edition'));
      return;
    }
    var t = e.target.closest('[data-o16-pml-dock-toggle]');
    if (!t) return;
    var pnl = dock && dock.querySelector('[data-o16-pml-dockpanel]');
    // No buttons in the bar yet (the book not published when the page loaded): go to the order card instead.
    if (pnl && !pnl.querySelector('[data-o16-pml-btn]')) {
      var card = root.querySelector('.o16-pmp__panel .o16-pml__live');
      if (card) card.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    setDockOpen(t.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDockOpen(false); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && Date.now() - lastFetch >= REFRESH) refresh(); });

  buttons();
  sample();
  tick();
})();
